<div class="row mx-1">
    <div class="col d-flex justify-content-center align-items-center px-0">
        <img class="shadow rounded-top-pages w-100" src="./assets/images/pc-banner.png" style=" height: 8rem;" alt="..." />
    </div>
</div>